import { css } from 'styled-components';

//TODO typing
export const textField = (Label: any, Input: any) => css`
	${Label} {
		display: block;
		${({ theme }) => theme.typography.label};
		margin-bottom: ${({ theme }) => theme.spacing.sm};
	}

	${Input} {
		box-sizing: border-box;
		width: 100%;
		margin: 0;
		padding: 18px 14px;
		font: inherit;
		border-radius: 4px;
		border: 1px solid grey;
	}
`;